import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

const mapTaskFromApi = (d) => ({
  id: Number(d.id || 0),
  companyId: Number(d.companyId || 0),
  companyName: d.companyName || '',
  title: d.title || '',
  description: d.description || '',
  assigneeBoardMemberId: d.assigneeBoardMemberId ? Number(d.assigneeBoardMemberId) : null,
  assigneeName: d.assigneeName || '',
  createdAtUtc: d.createdAtUtc || '',
  dueDateUtc: d.dueDateUtc || null,
  priority: d.priority || 'medium',
  status: d.status || 'new',
  linkedMeetingId: d.linkedMeetingId ? Number(d.linkedMeetingId) : null,
  linkedMeetingTitle: d.linkedMeetingTitle || '',
  linkedDecisionId: d.linkedDecisionId ? Number(d.linkedDecisionId) : null,
  linkedDecisionTitle: d.linkedDecisionTitle || '',
  followUpNotes: Array.isArray(d.followUpNotes) ? d.followUpNotes : [],
  updatedAtUtc: d.updatedAtUtc || '',
});

export const mapTaskFormToPayload = (form) => ({
  title: String(form.title || '').trim(),
  description: String(form.description || '').trim() || null,
  companyId: Number(form.companyId),
  assigneeBoardMemberId: form.assigneeBoardMemberId ? Number(form.assigneeBoardMemberId) : null,
  dueDateUtc: form.dueDateUtc || null,
  priority: form.priority || 'medium',
  status: form.status || 'new',
  linkedMeetingId: form.linkedMeetingId ? Number(form.linkedMeetingId) : null,
  linkedDecisionId: form.linkedDecisionId ? Number(form.linkedDecisionId) : null,
});

export async function fetchTasks(filters = {}) {
  const q = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v != null && String(v).trim() !== '' && String(v) !== 'all') q.set(k, String(v));
  });
  const res = await fetch(`${API_BASE}/api/tasks${q.toString() ? `?${q}` : ''}`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ([]));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل المهام'));
  return (Array.isArray(data) ? data : []).map(mapTaskFromApi);
}

export async function fetchTaskById(id) {
  const res = await fetch(`${API_BASE}/api/tasks/${id}`, { headers: { Accept: 'application/json', ...authHeaders() } });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل المهمة'));
  return mapTaskFromApi(data);
}

export async function createTask(payload) {
  const res = await fetch(`${API_BASE}/api/tasks`, { method: 'POST', headers: jsonHeaders(), body: JSON.stringify(payload) });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إنشاء المهمة'));
  return mapTaskFromApi(data);
}

export async function updateTask(id, payload) {
  const res = await fetch(`${API_BASE}/api/tasks/${id}`, { method: 'PUT', headers: jsonHeaders(), body: JSON.stringify(payload) });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تعديل المهمة'));
  return mapTaskFromApi(data);
}

export async function changeTaskStatus(id, status) {
  const res = await fetch(`${API_BASE}/api/tasks/${id}/status`, {
    method: 'PATCH',
    headers: jsonHeaders(),
    body: JSON.stringify(status),
  });
  if (res.status === 204) return;
  const data = await res.json().catch(() => ({}));
  throw new Error(messageFromErrorBody(data, 'تعذر تحديث الحالة'));
}

export async function addTaskFollowUpNote(id, text) {
  const res = await fetch(`${API_BASE}/api/tasks/${id}/notes`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify({ text }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إضافة الملاحظة'));
  return mapTaskFromApi(data);
}

export async function deleteTask(id) {
  const res = await fetch(`${API_BASE}/api/tasks/${id}`, { method: 'DELETE', headers: { Accept: 'application/json', ...authHeaders() } });
  if (res.status === 204) return;
  const data = await res.json().catch(() => ({}));
  throw new Error(messageFromErrorBody(data, 'تعذر حذف المهمة'));
}
